// Single source of truth for which roles may open each dashboard section.
// The sidebar builds its menu from these lists, and Dashboard.jsx enforces
// them again on render: sections are deep-linkable (/dashboard/<section>),
// so the menu filter alone no longer bounds what a user can open. Backend
// permissions remain the real data guard either way.
//
// Semantics (mirrors Sidebar.filterByRoles / RoleProtectedRoute):
// - superuser passes everything
// - 'borna-support' sections need is_support_staff (or superuser)
// - manager passes every non-support section
// - null = any authenticated user
export const SECTION_ROLES = {
  // پیکربندی‌ها
  'institute-info': ['manager'],
  'emails': ['manager'],
  'daily-report': ['manager'],
  // کاربران
  'staff-list': ['manager'],
  'teacher-list': ['manager'],
  'student-list': ['manager', 'secretary'],
  // برنامه‌های آموزشی
  'courses-list': ['manager'],
  'new-classroom': ['manager'],
  'teacher-schedule': ['manager', 'staff'],
  'student-schedule': ['manager', 'secretary', 'staff'],
  // فرآیندهای جاری
  'student-card': ['manager', 'secretary', 'staff'],
  'attendance-review': ['manager', 'secretary'],
  // دستیار هوشمند و نمای کلی (IsAssistantUser؛ ابزارها بر اساس نقش — spec 006 §4.3. خلاصهٔ روزانه فقط مدیر)
  'assistant': ['manager', 'secretary', 'accountant'],
  // آمار و ارقام
  'statistics': ['manager'],
  'classroom-info-graph': ['manager'],
  // حسابداری
  'institution-accounting': ['accountant'],
  'operation-browser': ['accountant'],
  'expense-register': ['accountant'],
  'teacher-accounting': ['accountant'],
  'teacher-salary-management': ['accountant'],
  'student-accounting': ['accountant', 'student'],
  'cashbox-reconciliation': ['accountant'],
  'bank-reconciliation': ['accountant'],
  // میانبرهای هدر
  'personal-notes': null,
  'colleague-notes': null,
  'support-chat': ['manager', 'secretary', 'accountant'],
  'staff-support-panel': 'borna-support',
};

export const getUserRoles = (user) => {
  const roles = Array.isArray(user?.roles)
    ? user.roles.map((r) => String(r).toLowerCase())
    : [];
  const staffName = user?.staff_role?.name;
  if (staffName) roles.push(String(staffName).toLowerCase());
  return Array.from(new Set(roles));
};

export const canAccessSection = (user, sectionId) => {
  if (!user) return false;
  if (user.is_superuser) return true;
  const required = SECTION_ROLES[sectionId];
  if (required === 'borna-support') return Boolean(user.is_support_staff);
  const roles = getUserRoles(user);
  if (roles.includes('manager')) return true;
  if (required == null) return true; // unknown ids fall back to the welcome screen anyway
  return roles.some((r) => required.includes(r));
};
